import { environment } from '@environments/environment';
import { ElasticSearchQueryInput, GeoFilterOptions, LocationFilter } from '@services/elastic-search/models';

export const GET_STORES_NEAR_COORDINATES_QUERY = (
  location: LocationFilter,
  geoFilterOptions: GeoFilterOptions = {
    searchRadiusKm: 50,
    sort: 'asc',
    includeClosedStores: false,
  }
): ElasticSearchQueryInput => ({
  query: '_search',
  index: environment.integrations?.fournierWebservice?.index_store ?? '',
  body: {
    size: 1000,
    query: {
      bool: {
        filter: [
          {
            term: {
              search_api_language: 'fr',
            },
          },
          {
            term: {
              search_api_datasource: 'entity:node',
            },
          },
          ...(geoFilterOptions.includeClosedStores
            ? []
            : [
                {
                  term: {
                    status: true,
                  },
                },
              ]),
          {
            geo_distance: {
              distance: `${geoFilterOptions.searchRadiusKm ?? 50}km`,
              latlon: {
                lat: location.lat,
                lon: location.lon,
              },
            },
          },
        ],
      },
    },
    sort: [
      {
        _geo_distance: {
          latlon: {
            lat: location.lat,
            lon: location.lon,
          },
          order: geoFilterOptions.sort ?? 'asc',
          unit: 'km',
          distance_type: 'arc',
        },
      },
    ],
  },
});
